import { data } from "./data";

export function buildSingleQuery(id: string) {
  return {
    queryKey: ["book", id],
    async queryFn() {
      return data.find((book) => book.id === id) ?? null;
    }
  };
}
